import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./app/router";
import vuetify from "./app/plugins/vuetify";
import "./styles/main.scss";
import VCalendar from "v-calendar";
import "v-calendar/style.css";
import maskDirective from "@/shared/directives/mask";


import 'flag-icons/css/flag-icons.min.css';
import 'v-phone-input/styles';
import { createVPhoneInput, selectPhoneCountryInput, VPhoneCountryFlagSvg } from 'v-phone-input';


const app = createApp(App);

const resizeObserverErrorHandler = (event: ErrorEvent) => {
	if (event.message === "ResizeObserver loop completed with undelivered notifications.") {
		event.stopImmediatePropagation();
		event.preventDefault();
	}
};

window.addEventListener("error", resizeObserverErrorHandler, true);


const vPhoneInput = createVPhoneInput({
	...selectPhoneCountryInput,
	countryDisplayComponent: VPhoneCountryFlagSvg,
});


import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

let currentEchoToken = "";

function getStoredAuthToken() {
	try {
		return localStorage.getItem("auth_token") || "";
	} catch {
		return "";
	}
}

function destroyEcho() {
	if (window.Echo?.disconnect) {
		window.Echo.disconnect();
	}
	window.Echo = undefined;
	currentEchoToken = "";
}

function initializeEcho(authToken: string) {
	if (!authToken) {
		destroyEcho();
		return;
	}

	if (window.Echo && currentEchoToken === authToken) {
		return;
	}

	destroyEcho();
	window.Pusher = Pusher;
	window.Echo = new Echo({
		broadcaster: "pusher",
		key: "local",
		cluster: "mt1",
		wsHost: process.env.VUE_REVERB_HOST || "reverb.systha.net",
		wsPort: 80,
		wssPort: 443,
		disableStats: true,
		forceTLS: false,
		authEndpoint: `${process.env.VUE_APP_API_URL || "https://api-test.systha.com/api/v1/platform"}/broadcasting/auth`,
		auth: {
			headers: {
				Authorization: `Bearer ${authToken}`,
				Accept: "application/json",
			},
		},
	});
	currentEchoToken = authToken;
	console.log("Echo initialized:", window.Echo);
}

function syncEchoWithAuth() {
	initializeEcho(getStoredAuthToken());
}

window.addEventListener("auth-changed", syncEchoWithAuth);
syncEchoWithAuth();


app.use(vPhoneInput);
app.use(createPinia());
app.use(router);
app.use(vuetify);
app.use(VCalendar, { componentPrefix: "Vc" });

app.directive("mask", maskDirective);

app.mount("#app");
